// extracted by mini-css-extract-plugin
export var testimonials = "slider-module--testimonials--3DGDi";
export var testimonials__next = "slider-module--testimonials__next--3I0oT";
export var testimonials__prev = "slider-module--testimonials__prev--2O-UX";
export var testimonials__wrap = "slider-module--testimonials__wrap--CzZRx";
export var testimonials__slider = "slider-module--testimonials__slider--2Q9SO";
export var testimonials__slider__image = "slider-module--testimonials__slider__image--MCNeD";
export var testimonials__slider__image__wrap = "slider-module--testimonials__slider__image__wrap--2wIcM";
export var testimonials__slider__image__bg = "slider-module--testimonials__slider__image__bg--_N5ES";
export var testimonials__slider__content = "slider-module--testimonials__slider__content--2kWGx";